import { useMemo } from 'react';

import { CreateMemberReminderDtoToneEnum } from 'src/Services/API/generated';
import {
  buildReminderTemplate,
  MemberReminderTemplateInput,
} from 'src/Utils/memberReminderTemplates';

const useToneTemplate = (
  tone: CreateMemberReminderDtoToneEnum,
  input: MemberReminderTemplateInput
) => {
  return useMemo(() => buildReminderTemplate(tone, input), [tone, input]);
};

export default useToneTemplate;
